import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';

const ROLES = {
  ADMIN: 'ADMIN',
  DATA_MANAGER: 'DATA_MANAGER',
  LOGISTICS_COORDINATOR: 'LOGISTICS_COORDINATOR',
  AREA_COORDINATOR: 'AREA_COORDINATOR',
  CLIENT: 'CLIENT',
};

const PERMISSIONS = {
  CREATE_DUKA: 'duka_add',
  EDIT_DUKA: 'duka_change',
  DELETE_DUKA: 'duka_delete',
  VIEW_DUKA: 'duka_view'
};

const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    PERMISSIONS.CREATE_DUKA,
    PERMISSIONS.EDIT_DUKA,
    PERMISSIONS.DELETE_DUKA,
    PERMISSIONS.VIEW_DUKA
  ],
  [ROLES.DATA_MANAGER]: [
    PERMISSIONS.VIEW_DUKA
  ],
  [ROLES.LOGISTICS_COORDINATOR]: [
    PERMISSIONS.EDIT_DUKA,
    PERMISSIONS.VIEW_DUKA
  ],
  [ROLES.AREA_COORDINATOR]: [
    PERMISSIONS.CREATE_DUKA,
    PERMISSIONS.EDIT_DUKA,
    PERMISSIONS.VIEW_DUKA
  ],
  [ROLES.CLIENT]: [
    PERMISSIONS.VIEW_DUKA
  ]
};

const usePermissions = () => {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasPermission = (permission) => {
    if (!user?.role?.name) return false;
    return ROLE_PERMISSIONS[user.role.name]?.includes(permission) || false;
  };

  const can = {
    createDuka: () => hasPermission(PERMISSIONS.CREATE_DUKA),
    editDuka: () => hasPermission(PERMISSIONS.EDIT_DUKA),
    deleteDuka: () => hasPermission(PERMISSIONS.DELETE_DUKA),
    viewDuka: () => hasPermission(PERMISSIONS.VIEW_DUKA)
  };

  return {
    loading,
    error,
    can,
    ROLES,
    PERMISSIONS
  };
};

export default usePermissions;
